export const SpaceRecentListRepository = Symbol.for('SpaceRecentListRepository');
